import Vue from "vue";
import Vuex from "vuex";
import tests from "./tests";
import users from "./users";
import purchase from "./purchase";
import notify from "./notify";

import createFetchUserPlugin from "./plugins/fetchUser";
import api from "../api/api";

const fetchUser = createFetchUserPlugin(api);
import reviews from "./reviews";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    tests,
    users,
    purchase,
    notify,
    reviews,
  },
  plugins: [fetchUser],
});

export default store;
